import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { JobService } from 'src/app/services/job.service';
import { UtilService } from 'src/app/services/util.service';
import { AppSettings } from './../../services/AppSettings';
import { CommonModule } from '@angular/common';
import { NG_ICON_DIRECTIVES, provideIcons } from '@ng-icons/core';
import { CommonSkeletonComponent } from '../../skeleton/common-skeleton/common-skeleton.component';
import { WIDGET_DATA } from 'src/app/components/suggestions/suggestions.component';
import { APP_ICONS } from '../../icons/icon-provider';

@Component({
  selector: 'app-community-admin',
  standalone: true,
  imports: [CommonModule, CommonSkeletonComponent, NG_ICON_DIRECTIVES],
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './community-admin.component.html',
  styleUrls: ['./community-admin.component.scss']
})
export class CommunityAdminComponent implements OnInit, OnChanges {

  @Input('title') title: any = 'Community Admins ';
  @Input() inputData: string;
  headerTitle: any = 'Community Admins ';
  commonDatahide: any = {}
  // Support both @Output EventEmitter and @Input callback function for NgComponentOutlet
  @Output() commonFunction: any = new EventEmitter<string>();
  admin: any = []
  @Input() maxMin: any = {};
  @Input() page: string;
  loadAPIcall:boolean=false
  viewType: string = "MIN";
  imgUrl: any = AppSettings.photoUrl;
  userName: string;

  @Input() widgetDesc: string;
  @Input() suggestion: any;

  constructor(
    private JobServicecolor: JobService,
    private auth: ApiService,
    private a_route: ActivatedRoute,
    private router: Router,
    private util: UtilService,
    @Optional() @Inject(WIDGET_DATA) private widgetData: any
  ) {
    console.log('CommunityAdminComponent: Constructor called, widgetData:', widgetData);
    // Apply injected widget data (Angular 15 NgComponentOutlet pattern)
    if (this.widgetData) {
      this.inputData = this.widgetData.inputData;
      this.page = this.widgetData.page;
      this.widgetDesc = this.widgetData.widgetDesc;
      this.suggestion = this.widgetData.suggestion;
      if (this.widgetData.commonFunction) {
        this.commonFunction = this.widgetData.commonFunction;
      }
      console.log('CommunityAdminComponent: Applied widgetData, inputData =', this.inputData);
    }
  }

  route(item) {
    this.router.navigate(['personalProfile'], { queryParams: item });

  }
  modelopen(data) {
    let dataPass: any = {};
    dataPass.data = data;
    dataPass.master = this.page;
    dataPass.menu = this.headerTitle || this.widgetDesc || 'Community Admins';
    dataPass.masterMenu = this.inputData;
    dataPass.widgetName = "CommunityAdmins";
    this.router.navigate(['suggestions'], { queryParams: dataPass })
  }

  getInitials(fullname: string): string {
    return this.JobServicecolor.getInitials(fullname);
  }

  getColor(fullname: string): string {
    return this.JobServicecolor.getColor(fullname);
  }
  getFullNameTextColor(fullname: string): string {
    return this.JobServicecolor.getFullnameTextColor(fullname);
  }
  
  getTextColor

  private apiCalled = false; // Prevent duplicate API calls

  ngOnChanges(changes: SimpleChanges): void {
    console.log('CommunityAdminComponent: ngOnChanges called with:', changes);
    console.log('CommunityAdminComponent: Current inputData:', this.inputData);

    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }

    // Handle inputData changes - this is critical for NgComponentOutlet
    if (changes.inputData && changes.inputData.currentValue) {
      console.log('CommunityAdminComponent: inputData changed to:', changes.inputData.currentValue);
      this.loadData();
    }
  }

  ngOnInit() {
    console.log('CommunityAdminComponent: ngOnInit called, inputData =', this.inputData);

    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }
    this.a_route.queryParams.subscribe((res) => {
      if (res.master != "NETWORK" && res.master != "TEAM" && res.menu != null && res.menu != undefined) {
        this.headerTitle = res.menu;
      }
    })

    if (this.maxMin.viewType != undefined) {
      this.viewType = "MAX";
      this.inputData = this.maxMin.master;
    }

    // Load data if inputData is already set (direct usage, not via NgComponentOutlet)
    this.loadData();
  }

  private loadData(): void {
    // Prevent duplicate API calls
    if (this.apiCalled) return;

    if (this.inputData && this.inputData != null && this.inputData != "") {
      if (this.inputData == "BUSINESS") {
        this.viewType = "MAX";

      } else if (this.inputData == "COMMUNITY") {
        this.apiCalled = true; // Mark as called
        this.loadAPIcall = true;
        this.viewType = "MIN"; // Keep widget visible
        const communityId = localStorage.getItem('communityId');
        console.log('CommunityAdminComponent: Calling API with communityId:', communityId);

        this.auth.query("community/admins/" + communityId).subscribe((res) => {
          this.loadAPIcall = false;
          this.util.stopLoader();
          console.log('CommunityAdminComponent: API response:', res);
          if (res && res?.data?.communityAdminsList && res?.data?.communityAdminsList.length > 0) {
            this.admin = res.data.communityAdminsList;
          } else {
            // No data - widget stays visible with "no data" message
            this.admin = [];
          }
        }, err => {
          this.loadAPIcall = false;
          this.util.stopLoader();
          this.admin = []; // Show "no data" message on error
          console.error('CommunityAdminComponent: API error:', err);
        });

      } else if (this.inputData == "HOME") {
        this.viewType = "MAX";
      }
    }
  }

  hide(flag) {
    this.commonDatahide.widgetName = "CommunityAdminComponent";
    this.commonDatahide.hide = flag;
    // Support both EventEmitter (template binding) and callback function (NgComponentOutlet)
    if (typeof this.commonFunction === 'function') {
      this.commonFunction(this.commonDatahide);
    } else if (this.commonFunction?.emit) {
      this.commonFunction.emit(this.commonDatahide);
    }
  }

}


